/**
 * My Space Reducer 注册中心
 *
 * 每次新建一个 slice，只需在这里加两行：
 *   1. import yourFeatureReducer from './yourFeatureSlice'
 *   2. 在 combineReducers 里加：yourFeature: yourFeatureReducer
 *
 * store.ts 已统一注册，不需要再动 store.ts。
 */

import { combineReducers } from '@reduxjs/toolkit'

// ↓↓↓ 在这里 import 你的 slice reducer ↓↓↓
import personalSpaceReducer from './personalSpaceSlice'

const mySpaceReducer = combineReducers({
  // ↓↓↓ 在这里注册你的 slice ↓↓↓
  personalSpace: personalSpaceReducer
})

export default mySpaceReducer
